export const mailchimpURL =
  "https://stirioficiale.us19.list-manage.com/subscribe/post?u=046bd86a80966c2ecaa0d84bf&amp;id=10738ac8bf";
